function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.109 4.67a.533.533 0 000 .76l1.03 1.028H5.154A.543.543 0 004.613 7c0 .298.244.542.542.542h4.983L9.11 8.57a.533.533 0 000 .758.533.533 0 00.758 0l1.945-1.944a.54.54 0 000-.764L9.867 4.67a.533.533 0 00-.758 0zM3.113 3.209h3.792a.543.543 0 00.541-.541.543.543 0 00-.541-.542H3.113c-.596 0-1.083.487-1.083 1.083v7.584c0 .595.487 1.083 1.083 1.083h3.792a.543.543 0 00.541-.542.543.543 0 00-.541-.541H3.113V3.208z",
  fill: "currentColor"
});

var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgLogout;